export const TeamChatComposerReferencePreviewTestIds = {
  ROOT: 'team-chat-composer-reference-preview.root',
};
